import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import LeftSidebar from './LeftSidebar';
import DashboardHeader from './DashboardHeader';

const DashboardLayout = () => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-[#fafafc] dark:bg-gray-900 font-sans overflow-hidden text-gray-900 dark:text-gray-100 transition-colors duration-200">
      {/* Left Sidebar */}
      <LeftSidebar 
        isMobileOpen={isMobileSidebarOpen} 
        onClose={() => setIsMobileSidebarOpen(false)} 
      />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative">
        <DashboardHeader onMenuClick={() => setIsMobileSidebarOpen(true)} />
        
        {/* Main Scrollable Content */}
        <main className="flex-1 overflow-y-auto px-4 sm:px-6 lg:px-8 pt-5 scrollbar-hide">
          <div className="max-w-full mx-auto w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
